<template>
  <v-data-table
    v-model="selected"
    calculate-widths
    disable-pagination
    :expanded="expanded"
    fixed-header
    :headers="headers"
    hide-default-footer
    item-key="id"
    :items="modifiedItems"
    :multi-sort="true"
    :no-data-text="$t('Tenders.NoData')"
    :show-select="true"
    @click:row="expandRow">
    <!-- Постачальник -->
    <template #[`item.supplier.title`]="{ item }">
      {{ item.supplier.title || '–' }}
    </template>
    <!-- Дата оновлення документів -->
    <template #[`item.statusChangeDate`]="{ item }">
      <div
        v-if="item.statusChangeDate"
        :data-qa="dataQa + '-document-updated-at'">
        {{ $d(new Date(item.statusChangeDate), "shortDate") }} {{ $d(new Date(item.statusChangeDate), "time") }}
      </div>
      <div
        v-else
        :data-qa="dataQa + '-document-updated-at'">
        –
      </div>
    </template>
    <!-- Статус -->
    <template #[`item.status`]="{ item }">
      <StatusChip
        class="mt-1 mr-1"
        :data-qa="dataQa + '-status'"
        key-name="id"
        :name="$t(`groupOfAccreditation.status.${item.status || '–'}`)"
        :status="item.status || '–'"
        text-color="var(--color-black)"
        value-name="title"/>
    </template>
    <!-- info-icons -->
    <template #[`item.infoIcons`]="{ item }">
      <div class="flex gap-4 flex-right">
        <GroupOfAccreditationStateChips :items="item.historyStats"/>
        <ModalGroupAccreditationsFeedback
          v-if="item"
          :data-qa="dataQa + '-feedback'"
          :value="item.feedback"/>
        <sButton
          v-if="item.files.length"
          :data-qa="dataQa + '-download-all-btn'"
          icon="download"
          small
          type="text"
          @click.stop="downloadArhive(item, 'requirementAllDocuments')"/>
      </div>
    </template>
    <template #expand_item_select="{ item, count }">
      <div>{{ item }}{{ count }}</div>
    </template>
    <template #expanded-item="{ item: itemProps }">
      <td
        class="pa-0 expanded-table-td"
        :colspan="1"/>
      <td
        class="pa-0 expanded-table-td text-left"
        :colspan="headers.length - 1">
        <div
          v-if="itemProps.requirements && itemProps.requirements.length"
          class="requirements">
          <div
            v-once
            class="font-size-14 mb-2 text-left bold">
            {{ $t('Tenders.Requirements') }}
          </div>
          <div class="requirements-list">
            <div
              v-for="(requirementItem, requirementIndex) in itemProps.requirements"
              :key="requirementItem.id + '_' + requirementIndex"
              class="requirements-list_item"
              :data-qa="dataQa + '-requirement-' + requirementIndex">
              <TooltipedTextLineCount
                :line-count="2"
                :line-height="1.25"
                :value="requirementItem.name"/>
              <DocumentList
                v-if="requirementItem.files && requirementItem.files.length"
                :attachments="requirementItem.files"
                :data-qa="dataQa + '-requirement-' + requirementIndex + '-list'"
                new-endpoints
                small/>
            </div>
          </div>
        </div>
        <div class="expanded-table-content">
          <div class="expanded-table-content_item">
            <div
              v-once
              class="font-size-14 my-2 text-left bold">
              {{ $t('Tenders.AboutParticipant') }}
            </div>
            <KeyValue
              :caption="$t('Tenders.EDRPOU')"
              class="py-2"
              :data-qa="dataQa + '-okpo'">
              {{ itemProps.supplier.okpo || '–' }}
            </KeyValue>
            <KeyValue
              :caption="$t('Tenders.ContactPerson')"
              class="py-2"
              data-qa="item-supplier-contactPerson">
              <div
                v-if="itemProps.supplier && itemProps.supplier.contactName"
                :data-qa="dataQa + '-fullName'">
                {{ itemProps.supplier.contactName }}
              </div>
              <div
                class="h8-text opacity-5">
                <div :data-qa="dataQa + '-email'">
                  {{ itemProps.supplier && itemProps.supplier.email ? itemProps.supplier.email : '–' }}
                </div>
                <div :data-qa="dataQa + '-phone'">
                  {{ itemProps.supplier && itemProps.supplier.phone ? itemProps.supplier.phone : '–' }}
                </div>
              </div>
            </KeyValue>
          </div>
          <div class="expanded-table-content_item">
            <div
              v-if="itemProps.files && itemProps.files.length"
              class="documents-header">
              {{ $t(`Tenders.Documents`) | firstUpperCase }}
              <sButton
                :data-qa="dataQa + '-download-all-btn'"
                icon="download"
                small
                type="text"
                @click="downloadArhive(itemProps, 'requirementDocuments')"/>
            </div>
            <DocumentList
              v-if="itemProps.files && itemProps.files.length"
              :attachments="itemProps.files"
              :data-qa="dataQa + '-document-list'"
              new-endpoints
              small/>
          </div>
          <div
            v-if="itemProps.history && itemProps.history.length"
            class="expanded-table-content_item">
            <div
              v-once
              class="font-size-14 my-2 text-left bold">
              {{ $t('Tenders.History') }}
            </div>
            <div
              class="overflow-y-auto text-left"
              style="max-height: 170px;">
              <div
                v-for="(historyItem, historyIndex) in itemProps.history"
                :key="historyItem.id + '_' + historyIndex"
                :data-qa="dataQa + '-history-item-' + historyIndex">
                <div class="font-size-12 opacity-8 flex align-center gap-2">
                  <div>
                    {{ $d(new Date(historyItem.statusChangeDate || historyItem.statusDate)) }}
                  </div>
                  <sButton
                    v-if="historyItem.files && historyItem.files.length"
                    :data-qa="dataQa + '-download-history-documents-btn-' + historyIndex"
                    small
                    type="text"
                    @click.stop="downloadArhive(itemProps, 'requirementHistoryItemDocuments', { sub: historyItem })">
                    <IconCount
                      class="ml-2"
                      :count="historyItem.files.length"
                      icon="download"
                      :icon-color="!historyItem.files.length ? 'grey': ''"
                      :text-class="{ 'grey--text': !historyItem.files.length }"/>
                  </sButton>
                </div>
                <div class="flex flex-between">
                  <StatusChip
                    class="pr-0 mt-1 mb-2"
                    :data-qa="dataQa + '-history-status-' + historyIndex"
                    key-name="id"
                    :name="$t(`groupOfAccreditation.status.${historyItem.status || '–'}`)"
                    :status="historyItem.status || '–'"
                    text-color="var(--color-black)"
                    value-name="title">
                    <ModalGroupAccreditationsFeedback
                      v-if="historyItem.feedback"
                      :data-qa="dataQa + '-history-feedback-btn-' + historyIndex"
                      :value="historyItem.feedback"/>
                  </StatusChip>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="itemProps && (itemProps.status === 'PENDING' || itemProps.status === 'ACCREDITED')"
            class="expanded-table-content_actions"
            style="vertical-align: top;">
            <sButton
              v-if="itemProps.status === 'PENDING'"
              :data-qa="dataQa + '-btn-accredit'"
              :disabled="sendResultLoading[itemProps.id]"
              :loading="sendResultLoading[itemProps.id]"
              @click="sendResult(itemProps.id, 'ACCREDITED')">
              {{ $t('groupOfAccreditation.accredited') }}
            </sButton>
            <sButton
              :data-qa="dataQa + '-btn-turn'"
              :disabled="sendResultLoading[itemProps.id]"
              :loading="sendResultLoading[itemProps.id]"
              type="text"
              @click="showModalInput(itemProps.id, 'REWORKING')">
              {{ $t('groupOfAccreditation.return') }}
            </sButton>
            <sButton
              :data-qa="dataQa + '-btn-decline'"
              :disabled="sendResultLoading[itemProps.id]"
              :loading="sendResultLoading[itemProps.id]"
              type="text"
              @click="showModalInput(itemProps.id, 'DECLINED')">
              {{ $t('Application.Reject') }}
            </sButton>
          </div>
        </div>
      </td>
      <td
        class="pa-0 expanded-table-td"
        :colspan="1"/> 
    </template>
    <template #[`body.append`]>
      <ModalInputTemplate
        ref="modalTemplate"
        :callback="(result) => sendResult(modalReworking.itemId, modalReworking.mode, result)"
        :data-qa="dataQa + '-modal-reworking'"
        :first-button="modalReworking.mode === 'DECLINED' ? $t('Application.Reject') : $t('groupOfAccreditation.return')"
        :form-data="form"
        :modal-title="modalReworking.mode === 'DECLINED' ? $t('groupOfAccreditation.rejectionOffer') : $t('groupOfAccreditation.returnOffer')"
        :options="{
          show: modalReworking.show,
          rules, maxLength: 4000,
          inputLabel: modalReworking.inputLabel }"
        @close="closeModalReworking"/>
    </template>
  </v-data-table>
</template>
<script>
import { StorageFile } from '@/types/commonFile.js'
import KeyValue from 'components/common/KeyValue.vue'
import IconCount from 'components/common/elements/IconCount.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'
import ModalInputTemplate from 'components/common/dialogs/ModalInputTemplate.vue'
import TooltipedTextLineCount from 'components/common/blocks/tooltiped text/TooltipedTextLineCount.vue'
import GroupOfAccreditationStateChips from 'components/group of accreditations/GroupOfAccreditationStateChips.vue'
import ModalGroupAccreditationsFeedback from 'components/group of accreditations/ModalGroupAccreditationsFeedback.vue'

import { validateRuls } from 'mixins'

import GroupOfAccreditationsApi from '@/api/groupOfAccreditationsApi'
const api = new GroupOfAccreditationsApi()

export default {
  name: 'GroupOfAccreditationItemRequests',
  mixins: [ validateRuls ],
  data() {
    return {
      headers: [
        {
          text: this.$t('Tenders.Supplier'),
          value: 'supplier.title',
          sortable: true,
        },
        {
          text: this.$t('Tenders.statusChangeDate'),
          value: 'statusChangeDate',
          width: '250px',
          sortable: true,
        },
        {
          text: this.$t('Common.Status'),
          value: 'status',
          sortable: true,
          width: '200px',
        },
        {
          value: 'infoIcons',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          sortable: false,
          width: '1px',
        }
      ],
      sendResultLoading: {},
      modalReworking: {
        show: false,
        itemId: null,
        inputLabel: this.$t('groupOfAccreditation.reasonReturn')
      },
      expanded: [],
      selected: [],
      form: {
        text: ''
      },
      rules: {
        text: []
      }
    }
  },
  methods: {
    downloadArhive(inputObject, arhiveType, objectProps) {
      this.$emit('downloadArhive', inputObject, arhiveType, objectProps)
    },
    closeModalReworking() {
      this.modalReworking.mode = ''
      this.modalReworking.show = false
      this.form.text = ''
    },
    showModalInput(itemId, mode) {
      this.modalReworking.inputLabel = mode === 'REWORKING'
        ? this.$t('groupOfAccreditation.reasonReturn')
        : this.$t('groupOfAccreditation.reasonReject')
      this.modalReworking.mode = mode
      this.modalReworking.itemId = itemId
      this.modalReworking.show = true
    },
    sendResult(itemId, newStatus, feedback = '') {
      this.$set(this.sendResultLoading, itemId, true)

      api.updateAccreditationRequest(this.accreditationGroupId, itemId, { status: newStatus, feedback: feedback ?? '' })
        .then((result) => {
          if (!result) {
            this.$log_error('Result updateAccreditationRequest is null')
            this.$notice.warning({
              title: this.$t('Common.ErrorTitle'),
              message: 'Помилка відправки результату',
              showClose: true,
              progress: true,
              duration: 10,
            })
            return
          }
          this.closeModalReworking()
          const newItems = [ ...this.modifiedItems ]
          newItems.find(item => item.id === itemId).status = newStatus
          this.modifiedItems = newItems
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.$set(this.sendResultLoading, itemId, false)
        })
    },
    expandRow(item) {
      let ind = this.expanded.findIndex(el => el.id == item.id)
      if (ind < 0) {
        this.expanded.push(item)
      } else {
        this.expanded.splice(ind, 1)
      }
    },
  },
  computed: {
    modifiedItems: {
      get() {
        return this.items.map((item) => {
          const files = item.files || []
          const requirements = item?.requirements?.map(requirement => {
            const requirementFiles = requirement.files || []
            return {
              ...requirement,
              files: requirementFiles.map(file => new StorageFile(null, file, 'Accreditation'))
            }
          }) || []
          return {
            ...item,
            requirements,
            files: files.map(file => new StorageFile(null, file, 'Accreditation'))
          }
        })
      },
      set(value) {
        this.$emit('update:items', value)
      }
    },
  },
  created() {
    this.rules.text = [
      this.$_validateRequired(true),
      ...this.$_validateMinMax(2, 4000, true)
    ]
  },
  filters: {
    firstUpperCase(val) {
      return val[0].toUpperCase() + val.slice(1)
    }
  },
  props: {
    accreditationGroupId: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    dataQa: {
      type: String,
      default: 'group-of-accreditation-requests'
    },
  },
  components: {
    KeyValue,
    IconCount,
    StatusChip,
    DocumentList,
    ModalGroupAccreditationsFeedback,
    ModalInputTemplate,
    TooltipedTextLineCount,
    GroupOfAccreditationStateChips
  }
}
</script>
<style lang="scss" scoped>
  .documents-header {
    display: flex;
    align-items: center;
    gap: 2px;
  }
  .expanded-table-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    &_item {
      flex: 1;
    }
    &_actions {
      display: grid;
      align-content: start;
      gap: 10px;
    }
  }
  .requirements {
    background: var(--v-main__light_green-base);
    padding: 15px;
    border-radius: 4px;
    margin: 0 -10px 12px;
    &-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-height: 162px;
      overflow: auto;
      &_item {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
    }
  }
</style>